import { Component } from 'react';
import { ReactComponent as Plus } from 'assets/images/svg/plus.svg';
import uploadImage from 'Helpers/uploadImage';
import Upload from 'Components/Common/Uploader';
import { toast as toastr } from 'react-toastify';
import fileTokenToBase64 from 'Helpers';
import Cropme from 'croppie';
import 'croppie/croppie.css';
import { ReactComponent as Loader } from 'assets/images/svg/loader.svg';
import { ReactComponent as Close } from 'assets/images/svg/Popclose.svg';

let dropArea;

var cropme;

const popUpOptions = {
    showZoomer: true,
    enableOrientation: true,
    viewport: { width: 150, height: 150, type: 'square' },
    boundary: { width: 300, height: 300 },
    initialZoom:-1
};

export default class DragUpload extends Component {

    state = { fileName:'', loading: false, popupState: false }
    componentDidMount() {
        if(this.props.dragEnable){
            dropArea = document.getElementById('dragable');
            [ 'dragenter', 'dragover', 'dragleave', 'drop' ].forEach(eventName => {
                dropArea.addEventListener(eventName, this.preventDefaults, false);
            });
            [ 'dragenter', 'dragover' ].forEach(eventName => {
                dropArea.addEventListener(eventName, this.highlight, false);
            });
            [ 'dragleave', 'drop' ].forEach(eventName => {
                dropArea.addEventListener(eventName, this.unhighlight, false);
            });

            dropArea.addEventListener('drop', this.handleDrop, false);
        }
    }

    preventDefaults = e => {
        e.preventDefault();
        e.stopPropagation();
    };

    highlight = e => {
        dropArea.classList.add('highlight');
    };

    unhighlight = e => {
        dropArea.classList.remove('highlight');
    };

    handleDrop = e => {
        e.preventDefault()
        const dt = e.dataTransfer;
        const fileElement = document.getElementById(`${ this.props.id }`)
        fileElement.files = dt.files;
        fileElement.dispatchEvent(new Event('change', { bubbles: true, }))
    };
   
    handleFileUpload = (fileType, file) => {
        this.uploadBeforeCropImage(file);
    }
    handleimageError = (error, message) => {
        if(this.props.imageError){
            this.props.imageError(error, message)
        }
    }

    cropInitilize = (event) => {
        event.preventDefault();
        this.setState({
            loading: true
        }, () => {
            cropme.result({
                type: 'base64'
            })
            .then(base64 => {
                const fileInstance = this.dataURLtoFile(base64, this.state.fileName);
                this.uploadImageAfterCrop(fileInstance)
            });
        })
    }

    uploadImageAfterCrop = (fileInstance) => {
        uploadImage(`type=${ this.props.type }`, fileInstance)
            .then(({ data }) => {
                const { fileToken } = data;
                const imageUrl = fileTokenToBase64(fileToken);
                this.setState({ loading: false,popupState:false },
                    () => this.props.updateImage(fileToken, this.state.fileName, imageUrl))
            })
            .catch(error => {
                toastr.error(error.toString());
            });
    }

    dataURLtoFile = (dataurl, filename) => {
        var arr = dataurl.split(','),
            mime = arr[ 0 ].match(/:(.*?);/)[ 1 ];
        const u8arr = Uint8Array.from(atob(arr[ 1 ]), c => c.charCodeAt(0));
        return new File([ u8arr ], filename, { type: mime });
    };

    uploadBeforeCropImage = (file) => {
        this.setState({
            popupState: true,
            fileName: file.name
        }, () => {
            const element = document.getElementById('container');
            cropme = new Cropme(element, popUpOptions);
            var reader = new FileReader();
            reader.onload = function (e) {
                cropme.bind({
                    url: e.target.result
                }).then(()=> cropme.setZoom(0));
            };
            reader.readAsDataURL(file);
        })
    };

    removeImage = () => {
        this.props.removeImage()
    };
    closePopUp = event => {
        event.preventDefault();
        this.setState({ popupState: false });
    };
    getUploadEle = () => {
        return <Upload
            dataValidation={ [ this.props.requiredfield ] }
            dataError='Please upload image'
            id={ this.props.id }
            type={ this.props.type || 'profile' }
            updateProfileImage={ this.handleFileUpload }
            imageError= { this.handleimageError }
            inputTypeFileComp = { this.props.inputTypeFileComp }
        />
    }
    getDraggableEle = () => {
        return <>
            <div className='profilelist'>
                <i className='uploadic' >
                    <label
                        htmlFor={ this.props.id }
                        className={ this.props.id }
                    >
                        <Plus />
                    </label>
                </i>
            </div>
            <div id='dragable' className='dragable'>
                { this.getUploadEle() }
                <label htmlFor={ this.props.id }>
                    Drag files here or <span>browse</span>
                </label>
            </div>
        </>
    }

    render() {
        const { id, type = 'profile', requiredfield = false, uploadImageError } = this.props;
        const { loading, popupState } = this.state;
        return (
            <>
                <div className='formgroup input-Wrapper upload'>
                    { this.props.dragEnable ? this.getDraggableEle() : this.getUploadEle() }
                    {uploadImageError && <span id="addadminupload-requiredfield" class="error">{ uploadImageError }</span> }
                </div>
                {popupState && (
                    <div className='profile-container'>
                        <div className='profile-popup-visible'>
                            <div className='popup-controls'>
                                <i onClick={ this.closePopUp } className='popup_close'><Close/></i>
                                <div id='container'></div>
                                {loading && (
                                    <div className='loader' style={ { zIndex:999 } }>
                                        <Loader style={ { width: 50, height: 50 } } />
                                    </div>
                                )}
                                <div className='popup_btn_footer'>
                                    <button onClick={ this.closePopUp } className='btn btn_outline'>Cancel</button>
                                    <button
                                        onClick={ this.cropInitilize }
                                     className='btn btn_primary'>
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        )
    }
}